import { HeroStyles } from './hero.style';
import { useForceBreakpoint } from '@exploration/ui-utils';
import { desktopBreakpoint } from '@thrivent/midwest-shared';
import { sanitize } from 'isomorphic-dompurify';
import ReactHtmlParser from 'react-html-parser';

const { Title, ImageContainer, Image } = HeroStyles;

export interface HeroSectionProps {
  headline: string;
  image?: {
    alt: string;
    source: {
      publicUrl: string;
    };
  };
}

const HeroSection = ({ headline, image }: HeroSectionProps) => {
  // This is to negate when we are passing back html tags as part of the headline for screen reader
  let headlineString = '';
  ReactHtmlParser(headline).forEach((str) => {
    if (typeof str === 'string') {
      headlineString = headlineString.concat(str);
    }
  });

  Title.defaultProps = {
    forceMobileBreakpoint: useForceBreakpoint() === 'mobile',
  };

  ImageContainer.defaultProps = {
    forceMobileBreakpoint: useForceBreakpoint() === 'mobile',
  };

  return (
    <>
      <Title aria-label={headlineString} as="h1">
        <span aria-hidden>{ReactHtmlParser(sanitize(headline))}</span>
      </Title>
      {image && (
        <ImageContainer>
          <Image
            src={image.source.publicUrl}
            alt={image.alt}
            fill
            priority
            quality={100}
            sizes={`(max-width: ${desktopBreakpoint}px) 100vw, 60vw`}
          />
        </ImageContainer>
      )}
    </>
  );
};

export default HeroSection;
